import { $ } from 'utils'
import styled from 'glamorous'
import map from 'lodash/map'
import Route from 'react-router-dom/Route'
import Redirect from 'react-router-dom/Redirect'
import Switch from 'react-router-dom/Switch'
import { SignIn, SignUp } from './SignForm'

const MainContainer = styled.div({
  height: '100%',
  width: '100%',
})

const BgContainer = styled.div({
  height: '100%',
  width: '100%',
  display: 'flex',
})

const BgLeft = styled.div({
  flex: 9,
  display: 'flex',
  backgroundColor: '#dfe6ec'
})

const BgRight = styled.div({
  flex: 10,
  backgroundColor: 'var(--bgColor)'
})

const signPages = {
  signIn: () => $(SignIn),
  signUp: () => $(SignUp, { isSignUp: true }),
}

const PageRoute = (component, type) =>
  $(Route, { key: type, type, path: `/${type}`, component })


const SignLayout = () =>
  $(MainContainer,
    $(BgContainer,
      $(BgLeft),
      $(BgRight),
    ),
    $(Switch,
      map(signPages, PageRoute),
      $(Redirect, { to: '/signIn' })
    )
  )

export default SignLayout



// WEBPACK FOOTER //
// ./src/pages/SignLayout/index.js